import detalhesCompra from '../../components/DetalhesCompra/detalhesCompra.vue';

export default {
    name: "DetalhamentoCompra",
    components: { detalhesCompra }
}